// src/i18n/locales/vietrro-vi.ts

export default {
  common: {
    // Brand message
    brandMessage: "Bảo vệ Quyền sao chép là bảo vệ \nsự sáng tạo và phát triển",
    brandName: "VIETRRO",
    author: "Tác giả",
    work: "Tác phẩm",
    certificate: "Chứng nhận",
    certificate_other: "Giấy chứng nhận",
    category: "Danh mục",
    hashtag: "Từ khóa",
    hashtagNote: "phân cách bằng dấu phẩy",
    other: "Khác",
    file: "Tệp",
    violationReport: "Báo cáo vi phạm",
    dataInputEmpty: "Không có dữ liệu",
    dataEmpty: "Không có {{topic}}",
    noDataTopic: "Chưa có {{topic}} nào",
    firstWork: "Hãy tạo tác phẩm đầu tiên của bạn",
    notFound: "Không tìm thấy {{topic}}",
    selectTopic: "Chọn {{topic}}",
    paginationShow: "Hiển thị {{count}} trong {{total}} {{topic}}",
    error: "Lỗi",
    no: "Không",
    yes: "Có",
    protected: "Được bảo vệ",
    hasThumbnail: "Có ảnh đại diện",
    joinedDate: "Tham gia",
    all: "Tất cả",
    search: "Tìm kiếm",
    searchPlaceholder: "Nhập từ khóa...",
    searchPlaceholderTopic: "Tìm kiếm {{topic}}...",
    filter: "Lọc",
    publishedMarketplace: "Đã đăng Marketplace",
    unpublishedMarketplace: "Chưa đăng Marketplace",
    publishedMarketplaceShort: "Marketplace",
    unpublishedMarketplaceShort: "Chưa đăng",
    selectedTopic: "{{topic}} đã chọn",
    deleting: "Đang xóa...",
    type: "Loại",
    status: "Trạng thái",
    filterApply: "Bộ lọc đang áp dụng",
    homePage: "Trang chủ",
    returnWorksPage: "Quay lại danh sách",
    classification: "Phân loại",
    publicDisplay: "Hiển thị công khai",
    allowPublicDisplay: "Cho phép tác phẩm được hiển thị trong danh mục công khai",
    uploadDescription: "Kéo và thả các tệp vào đây hoặc nhấp để duyệt",
    uploadFormats: "Hỗ trợ: JPEG, PNG, GIF, MP3, MP4, PDF, DOC, TXT (tối đa 100MB)",
    upLoading: "Đang tải lên...",
    upLoadSuccess: "Upload hoàn tất!",
    userProfile: "Hồ sơ cá nhân",
    setting: "Cài đặt",
    overview: "Tổng quan",
    request: "Yêu cầu",
    analytic: "Thống kê",
    earning: "Thu nhập",
    newNotification: "Thông báo mới",
    character: "Ký tự",
    minimum: "Tối thiểu",
    maximum: "Tối đa",
    popular: "Phổ biến",
    price: "Giá",
    priceSuggest: "Giá gợi ý",
    durationUnit: "Ngày",
    topicLoading: "Đang tải {{topic}}...",
    content: "Nội dung",
    filterTopicEmpty: "Không tìm thấy {{topic}} phù hợp",
    vietrroCertificate: 'Giấy phép Vietrro',
    wipoCertificate: 'Giấy phép WIPO',
    noipCertificate: 'Giấy phép Cục SHTT',
    associationCertificate: 'Giấy phép Hiệp hội',
    downloadCertificate: 'Tải chứng nhận',
    certificateType: 'Loại chứng nhận',
    issueDate: "Ngày cấp",
    expiryDate: "Ngày hết hạn",
    description: "Mô tả",
    actions: "Thao tác",
    copyLink: "Sao chép liên kết",
    copied: "Đã sao chép",
    share: "Chia sẻ",
    detail: "Thông tin chi tiết",
    undefined: "Không xác định",
    owner: "Chủ sở hữu",
    ownership: "Quyền sở hữu",
    noDescription: "Không có mô tả",

    

    support: {
      pageNotFound: {
        title: "Trang không tồn tại",
        subTitle: "Rất tiếc, Bạn hiện không xem được nội dung này.",
      },
      pageError: {
        title: "Lỗi Truy cập",
        subTitle: "Phiên đăng nhập của bạn đã hết hạn hoặc bạn không có quyền xem trang này. \nVui lòng đăng nhập lại để tiếp tục."
      },
      message: "Nếu bạn cho rằng có sự cố, vui lòng liên hệ với chúng tôi để được trợ giúp.",
    },
    button: {
      next: "Tiếp tục",
      back: "Bước trước",
      changePassword: "Thay đổi mật khẩu",
      sendResetLink: "Gửi liên kết đặt lại mật khẩu",
      login: "Đăng nhập",
      signInNow: "Đăng nhập ngay",
      backToLogin: "Quay lại đăng nhập",
      contactSupport: "Liên hệ hỗ trợ",
      backToHome: "Về trang chủ",
      goBack: "Quay lại",
      register: "Đăng ký tài khoản",
      joinNow : "Tham gia ngay",
      registerNow : "Đăng ký ngay",
      processing: "Đang xử lý...",
      loading: "Đang tải...",
      registerWork: "Đăng ký tác phẩm",
      registerNewWork: "Đăng ký Tác phẩm mới",
      registerWorkNow: "Đăng ký tác phẩm ngay",
      discoverMarketplace: "Khám phá Marketplace",
      marketplace: "Marketplace",
      viewAll: "Xem tất cả",
      viewAllTopic: "Xem tất cả {{topic}}",
      viewDetail: "Chi tiết",
      viewProfile: "Xem hồ sơ",
      refresh: "Làm mới",
      uploadButton: "Chọn tệp",
      remove: "Xóa",
      cancel: "Hủy",
      cancelRemove: "Hủy xóa",
      addTopic: "Thêm {{topic}}",
      freeRegister: "Đăng ký miễn phí",
      learnMore: "Tìm hiểu thêm",
      exportData: "Xuất dữ liệu",
      deleteSelected: "Xóa đã chọn",
      deselect: "Bỏ chọn",
      viewFile: "Xem file",
      willBeRemove: "Sẽ được xóa",
      addNewFiles: "Thêm files mới",
      saveChanges: "Lưu thay đổi (v{{ver}})",
      create: "Tạo mới",
      publishToMarketplace: "Đăng lên Marketplace",
      removeFromMarketplace: "Gỡ khỏi Marketplace",
      verify: "Xác thực",
      download: "Tải xuống",
      edit: "Chỉnh sửa",
    },
    contentKind: {
      label: "Loại nội dung",
      image: "Hình ảnh",
      video: "Video",
      audio: "Âm thanh",
      text: "Văn bản",
      other: "Khác",
    },
    userStatus: {
      verified: "✓ Đã xác thực",
      Unverified: "⏳ Chưa xác thực",
    },
    contentStatus: {
      label: "Trạng thái",
      draft: "Nháp",
      submitted: "Chờ xem xét",
      pending: "Chờ xem xét",
      under_review: "Đang được xem xét",
      approved: "Đã duyệt",
      rejected: "Từ chối",
      revision_required: "Cần chỉnh sửa",
      published: "Đã xuất bản",
      suspended: "Tạm ngưng hiển thị",
      deleted: "Tạm ngưng hiển thị",
      archived: "Lưu trữ",
    },
    sortBy: {
      label: "Sắp xếp",
      title: "Tiêu đề",
      registrationDate: "Ngày đăng ký",
      licenseCount: "Số license",
      viewCount: "Lượt xem",
      protectionScore: "Điểm bảo vệ",
    },
    title: {
      imageProtection: "Bảo vệ hình ảnh",
      collaborator: "Người đóng góp",
    },
    watermark: {
      ownerView: "Chủ sở hữu sẽ thấy hình ảnh gốc không có watermark.",
      applied: "Hình ảnh sẽ được thêm watermark \"tacquyen.vn + VIETRRO\" để bảo vệ bản quyền.",
    },
    footer: {
      description: "Giải pháp bảo vệ bản quyền và danh tính toàn diện cho các nhà sáng tạo nội dung.",
      termsOfUse: "Điều khoản sử dụng",
      privacyPolicy: "Chính sách bảo mật",
      legal: "Pháp lý",
      sitemap: "Sơ đồ trang",
      copyright: "© 2025 Vietrro. Bảo lưu mọi quyền.",
      feature: {
        title: "Điểm nổi bật",
        identityProtection: "Bảo vệ danh tính",
        copyrightMonitoring: "Giám sát Bản quyền",
        autoDMCA: "DMCA tự động",
        aiUsageDetection: "Phát hiện sử dụng AI",
        marketplace: "Marketplace"
      },
      support: {
        title: "Hỗ trợ",
        helpCenter: "Trung tâm trợ giúp",
        community: "Cộng đồng",
        contactSupport: "Liên hệ hỗ trợ",
        faq: "Câu hỏi thường gặp",
        resources: "Tài nguyên"
      },
      aboutUs: {
        title: "Về chúng tôi",
        aboutUs: "Giới thiệu",
        careers: "Tuyển dụng",
        blog: "Blog",
        press: "Báo chí",
        partners: "Đối tác"
      }
    },
    message: {
      confirmCancelMessage: "Bạn có chắc chắn muốn hủy bỏ các thay đổi?",
      updateTopicFailMessage: `Cập nhật {{topic}} thất bại!`,
      confirmDeleteContent: {
        title: "Xác nhận xóa",
        message: "Bạn có chắc chắn muốn xóa tác phẩm này?",
        description: "Hành động này không thể hoàn tác.",
      }

    },
    notifications: {
      title: "Thông báo",
      markAllAsRead: "Chuyển tất cả",
    },
  },
  userGroup: {
    primaryUsers: {
      "name": "Người Dùng Chính",
      "description": "Bao gồm: Người Sở Hữu Bản Quyền, Người Sử Dụng Bản Quyền, Đại Lý Bản Quyền",
    },
    educationUsers: {
      "name": "Người dùng Giáo dục",
      "description": "Nhóm chung cho tất cả người dùng của module giáo dục",
    },
    teachers: {
      "name": "Giáo viên",
      "description": "Nhóm giáo viên có quyền tải lên và quản lý tài liệu",
    },
    supportMonitoring: {
      "name": "Người Dùng Hỗ Trợ & Giám Sát",
      "description": "Bao gồm: Nhóm Pháp Lý, Bộ Phận Kiểm Duyệt & Thực Thi Bản Quyền",
    },
    students: {
      "name": "Học sinh/Sinh viên",
      "description": "Nhóm học sinh và sinh viên",
    },
    guestBusinessPartners: {
      "name": "Người Dùng Khách Hàng & Đối Tác",
      "description": "Bao gồm: Khách Hàng Vãng Lai, Đối Tác Công Nghệ & Doanh Nghiệp",
    },
    contentApiManagement: {
      "name": "Người Dùng Quản Lý Nội Dung & Tích Hợp API",
      "description": "Bao gồm: Người Kiểm Duyệt Nội Dung, Quản Lý Nội Dung, Nhà Phát Triển Tích Hợp API, Đối Tác Quản Lý & Phân Phối",
    },
    specialQualityManagement: {
      "name": "Người Dùng Đặc Biệt & Quản Lý Chất Lượng",
      "description": "Bao gồm: Người Đánh Giá Nội Dung, Người Dùng VIP, Nhà Đầu Tư Bản Quyền",
    },
    independentIndustryExperts: {
      "name": "Người Dùng Độc Lập & Chuyên Gia Ngành",
      "description": "Bao gồm: Người Tạo Nội Dung Tự Do, Chuyên Gia Ngành Công Nghiệp Bản Quyền, Nhà Phát Triển AI Kiểm Duyệt Nội Dung",
    },
    educationTraining: {
      "name": "Giáo Dục & Đào Tạo",
      "description": "Bao gồm: Copyright Educators, Academic Users",
    },
    legalTeamEx: {
      "name": "Hỗ Trợ Khách Hàng",
      "description": "Bao gồm: Support Specialists, Onboarding Experts",
    }
  },
  
  pageContent: {
    login: {
      // Page metadata
      pageTitle: "Đăng nhập hệ thống | Vietrro",
      pageDescription: "Vietrro, nền tảng quản lý Bản quyền toàn diện.",
      pageKeywords: "register, login, vietrro, đăng ký, đăng nhập, tạo tài khoản",

      // Main content
      title: "Đăng nhập",
      subtitle: "Hãy đăng nhập để khám phá đầy đủ tính năng và \ntiện ích dành riêng cho thành viên.",
      
      // Form fields
      username: "Tên đăng nhập",
      password: "Mật khẩu",
      usernamePlaceholder: "Tên đăng nhập",
      passwordPlaceholder: "Mật khẩu",

      // Form actions
      rememberMe: "Ghi nhớ đăng nhập",
      forgotPassword: "Quên mật khẩu?",
      loginButton: "Đăng nhập",
      loginButtonLoading: "Đang đăng nhập...",

      // Navigation
      noAccount: "Chưa có tài khoản?",
      registerNow: "Đăng ký ngay",

      // Messages
      loginSuccess: "Đăng nhập thành công",
      ValidationError: "Thông tin đăng nhập không chính xác",
      requiredFields: "Vui lòng nhập đầy đủ thông tin",
      networkError: "Lỗi kết nối mạng, vui lòng thử lại",      
    },
    register: {
      // Page metadata
      pageTitle: "Đăng Ký Tài Khoản | Vietrro",
      pageDescription: "Vietrro, nền tảng quản lý Bản quyền toàn diện.",
      pageKeywords: "register, login, vietrro, đăng ký, đăng nhập, tạo tài khoản",

      // Main content
      title: "Đăng Ký Tài Khoản Vietrro",
      subtitle: "Tạo tài khoản mới để quản lý bản quyền",
      alreadyHaveAccount: "Đã có tài khoản?",
      

      // Steps
      steps: {
        selectRole: "Chọn vai trò",
        personalInfo: "Thông tin cá nhân",
        confirm: "Xác nhận"
      },

      // Step 1 - Role Selection
      roleSelection: {
        title: "Chọn vai trò của bạn trong hệ thống",
        multipleRolesSwitch: "Chọn nhiều vai trò",
        selectedRoles: "Vai trò đã chọn:",
        noRolesSelected: "Chưa chọn vai trò nào",
        noGroupsAvailable: "Không có nhóm người dùng nào có thể đăng ký."
      },

      // Step 2 - Personal Information
      personalInfo: {
        title: "Thông tin cá nhân",
        firstName: "Họ",
        lastName: "Tên",
        username: "Tên đăng nhập",
        email: "Email",
        phone: "Số điện thoại",
        password: "Mật khẩu",
        confirmPassword: "Xác nhận mật khẩu",
        
        // Business fields
        businessInfo: "Thông tin tổ chức",
        organization: "Tổ chức/ Doanh nghiệp",
        taxId: "Mã số thuế"
      },

      // Step 3 - Confirmation
      confirmation: {
        title: "Xác nhận thông tin",
        role: "Vai trò:",
        fullName: "Họ và tên:",
        specificRoles: "Các vai trò cụ thể:",
        approvalNote: "Tài khoản của bạn sẽ cần được phê duyệt trước khi có thể sử dụng đầy đủ tính năng.",
        approvalNoteTitle: "Lưu ý:",
        agreeTerms: "Tôi đồng ý với",
        termsOfUse: "Điều khoản sử dụng",
        and: "và",
        privacyPolicy: "Chính sách bảo mật",
        ofVietrro: "của Vietrro"
      },

      // Buttons
      buttons: {
        continue: "Tiếp tục",
        back: "Quay lại",
        register: "Đăng ký tài khoản",
        processing: "Đang xử lý..."
      },

      // Messages
      messages: {
        loading: "Đang tải...",
        loadingInfo: "Đang tải thông tin...",
        dataLoadError: "Không thể tải dữ liệu. Vui lòng thử lại sau",
        usernameExists: "Tên đăng nhập đã tồn tại hoặc không hợp lệ, vui lòng chọn tên khác",
        emailInvalid: "Email không hợp lệ, vui lòng chọn email khác",
        registrationFailed: "Đăng ký thất bại. Vui lòng thử lại."
      },

      // Validation messages
      validation: {
        selectAtLeastOneRole: "Vui lòng chọn ít nhất một vai trò",
        firstNameRequired: "Vui lòng nhập họ",
        lastNameRequired: "Vui lòng nhập tên",
        usernameRequired: "Vui lòng nhập tên đăng nhập",
        usernameMinLength: "Tên đăng nhập phải có ít nhất 4 ký tự",
        usernameMaxLength: "Tên đăng nhập tối đa chỉ 30 ký tự",
        usernameExists: "Tên đăng nhập đã tồn tại hoặc không hợp lệ",
        emailRequired: "Vui lòng nhập email",
        emailInvalid: "Email đăng ký đã tồn tại hoặc không hợp lệ",
        passwordRequired: "Vui lòng nhập mật khẩu",
        passwordMinLength: "Mật khẩu phải có ít nhất 8 ký tự",
        confirmPasswordRequired: "Vui lòng xác nhận mật khẩu",
        passwordMismatch: "Mật khẩu xác nhận không khớp",
        phoneInvalid: "Số điện thoại đã tồn tại hoặc không hợp lệ",
        agreeTermsRequired: "Vui lòng đồng ý với điều khoản sử dụng"
      },

    },

    forgotPassword: {
      // Page metadata
      pageTitle: "Khôi phục mật khẩu | Vietrro",
      pageDescription: "Vietrro, nền tảng quản lý Bản quyền toàn diện.",
      pageKeywords: "register, login, vietrro, đăng ký, đăng nhập, tạo tài khoản",

      // Brand
      brandMessage: "Bảo vệ Quyền sao chép là bảo vệ \nsự sáng tạo và phát triển",
      brandName: "VIETRRO",

      // Main content
      title: "Đặt lại mật khẩu",
      subtitle: "Vì lý do bảo mật, vui lòng xác nhận thông tin \nđể chúng tôi hỗ trợ bạn đặt lại mật khẩu.",

      // Form fields
      emailLabel: "Email đăng ký",
      emailPlaceholder: "Nhập email của bạn",
      newPasswordLabel: "Mật khẩu mới",
      newPasswordPlaceholder: "Nhập mật khẩu mới",
      confirmPasswordLabel: "Xác nhận mật khẩu",
      confirmPasswordPlaceholder: "Xác nhận mật khẩu mới",
      otpLabel: "Mã OTP",
      otpPlaceholder: "Nhập OTP",

      // Messages
      processing: "Đang xử lý...",
      success: "Thành công!",
      successMessage: "Mật khẩu của bạn đã được thay đổi thành công. \nVui lòng đăng nhập để tiếp tục",
      otpSentSuccess: "Mã xác thực đã được gửi \ntới email của bạn!",
      resetLinkSent: "Link thay đổi password đã được gửi \ntới email của bạn!",
      
      // Error messages
      otpSendError: "Không thể gửi mã xác thực. \nVui lòng kiểm tra lại thông tin và thử lại.",
      passwordMismatch: "Password không trùng khớp! \nVui lòng kiểm tra thông tin và thử lại.",
      otpVerifyError: "Xác thực OTP thất bại",
      generalError: "Đã xảy ra lỗi. Vui lòng thử lại sau.",

      // Navigation
      rememberPassword: "Nhớ mật khẩu?",
    },
    home: {
      // Page metadata
      pageTitle: "Vietrro - Nền tảng Bảo vệ Bản quyền",
      pageDescription: "Vietrro là nền tảng bảo vệ bản quyền toàn diện giúp các nhà sáng tạo bảo vệ, quản lý và kiếm tiền từ tài sản trí tuệ với công nghệ AI tiên tiến và các công cụ thực thi pháp lý.",
      pageKeywords: "bảo vệ bản quyền, tài sản trí tuệ, bảo vệ nội dung, giám sát AI, thực thi pháp lý, quản lý quyền số, bảo vệ nhà sáng tạo, cấp phép nội dung",

      // Hero Section
      hero: {
        title: "Bảo vệ tác phẩm của bạn",
        subtitle: "Giải pháp toàn diện để bảo vệ bản quyền và quản lý danh tính trực tuyến",
        description: "Tham gia cùng hàng nghìn nhà sáng tạo tin tưởng Vietrro để bảo vệ, quản lý và kiếm tiền từ tài sản trí tuệ với công nghệ tiên tiến và hỗ trợ pháp lý toàn diện.",
        protectedWorks: "Tác phẩm được Bảo vệ",
        activeUsers: "Tác giả tin tưởng",
      },

      // Recent Works Section
      recentWorks: {
        title: "Tác phẩm Được Bảo vệ Gần đây",
        subtitle: "Nội dung mới nhất được thêm vào hệ thống bảo vệ",
        description: "Khám phá những tác phẩm sáng tạo mới nhất đã được đăng ký và bảo vệ thông qua nền tảng của chúng tôi.",
        viewAll: "Xem Tất cả Tác phẩm",
        noWorks: "Hiện tại chưa có tác phẩm được bảo vệ nào",
        loading: "Đang tải tác phẩm gần đây...",
        workCard: {
          protectedOn: "Được bảo vệ vào",
          by: "bởi",
          category: "Danh mục",
          viewDetails: "Xem Chi tiết",
          downloadCertificate: "Tải Chứng chỉ"
        },
        filters: {
          all: "Tất cả Tác phẩm",
          documents: "Tài liệu",
          images: "Hình ảnh",
          videos: "Video",
          audio: "Âm thanh",
          software: "Phần mềm"
        }
      },

      // Featured Users Section
      featuredUsers: {
        title: "Tác giả nổi bật",
        subtitle: "Những Tác giả nổi bật trong cộng đồng Vietrro",
        description: "Gặp gỡ cộng đồng tài năng của các nhà sáng tạo đang tích cực bảo vệ tài sản trí tuệ của họ.",
        totalFeaturedAuthors: "({{total}}) Tác giả nổi bật",
        totalOwnership: "({{total}}) chủ quyền",
        totalPrimaryUsers: "({{total}}) Người dùng chính",
        totalVerifiedUsers: "({{total}}) đã xác thực",
        noUser: {
          title: "Chưa có tác giả nổi bật",
          subtitle: "Hãy quay lại sau để khám phá những tác giả tài năng"
        },
        loading: "Đang tải tác giả nổi bật...",
        userCard: {
          member: "Thành viên",
          since: "từ",
          works: "tác phẩm",
          certificates: "chứng chỉ",
          viewProfile: "Xem Hồ sơ",
          contact: "Liên hệ"
        },
        stats: {
          totalWorks: "Tổng Tác phẩm",
          activeCertificates: "Chứng chỉ Hoạt động",
          joinedDate: "Tham gia",
          lastActive: "Hoạt động Cuối"
        },
        action: {
          title: "Bạn cũng là một tác giả?",
          subtitle: "Tham gia cộng đồng Vietrro để chia sẻ tác phẩm và kết nối với những người sáng tạo khác"
        }
      },

      // Active Certificates Section
      activeCertificates: {
        title: "Chứng nhận bản quyền",
        title2: "đang bảo vệ",        
        subtitle: "Theo dõi và quản lý các giấy chứng nhận bản quyền đang có hiệu lực, \nđảm bảo tác phẩm của bạn được bảo vệ toàn diện",
        noteNoCertificates: "Bắt đầu bảo vệ tác phẩm của bạn bằng cách đăng ký chứng nhận bản quyền ngay hôm nay.",
        
        // certificateCard: {
        //   certificateId: "Mã Chứng chỉ",
        //   issuedOn: "Được cấp vào",
        //   validUntil: "Có hiệu lực đến",
        //   work: "Tác phẩm",
        //   owner: "Chủ sở hữu",
        //   status: "Trạng thái",
        //   download: "Tải về",
        //   verify: "Xác minh",
        //   viewWork: "Xem Tác phẩm"
        // },
        // status: {
        //   active: "Hoạt động",
        //   expired: "Hết hạn",
        //   suspended: "Tạm ngưng",
        //   revoked: "Thu hồi"
        // },
        stat: {
          total: "Tổng cộng",
          vietrro: "Vietrro",
          wipo: "WIPO",
        },
        action: {
          title: "Bảo vệ toàn diện tác phẩm của bạn",
          subtitle: "Đăng ký chứng nhận bản quyền với các tổ chức uy tín để đảm bảo \ntác phẩm được bảo vệ hoàn toàn trước mọi vi phạm"
        },
        highlight: {
          autoProtect: {
            title: "Bảo vệ tự động",
            sbutitle: "Hệ thống AI giám sát 24/7 để phát hiện vi phạm bản quyền"
          },
          international: {
            title: "Bảo vệ quốc tế",
            sbutitle: "Chứng nhận được công nhận tại hơn 190 quốc gia trên thế giới"
          },
          valueIncrease: {
            title: "Gia tăng giá trị",
            sbutitle: "Chứng nhận giúp tăng giá trị thương mại của tác phẩm"
          }
        }
      },

      // Recent Violations Section
      recentViolations: {
        title: "Vi phạm gần đây",
        subtitle: "Cập nhật tình hình bảo vệ tác phẩm",
        description: "Theo dõi các báo cáo vi phạm bản quyền gần đây và các hành động thực thi.",
        viewAll: "Xem Tất cả Báo cáo",
        reportViolation: "Báo cáo Vi phạm",
        noViolations: "Không có báo cáo vi phạm nào",
        loading: "Đang tải báo cáo vi phạm...",
        violationCard: {
          reportId: "Mã Báo cáo",
          reportedOn: "Được báo cáo vào",
          work: "Tác phẩm",
          reporter: "Người báo cáo",
          status: "Trạng thái",
          priority: "Độ ưu tiên",
          viewDetails: "Xem Chi tiết",
          takeAction: "Thực hiện Hành động"
        },
        status: {
          pending: "Chờ xử lý",
          investigating: "Đang điều tra",
          resolved: "Đã giải quyết",
          dismissed: "Đã bỏ qua",
          escalated: "Đã leo thang"
        },
        priority: {
          low: "Thấp",
          medium: "Trung bình",
          high: "Cao",
          critical: "Nghiêm trọng"
        }
      },

      // Quick Actions Section
      quickActions: {
        title: "Thao tác Nhanh",
        subtitle: "Truy cập nhanh các tính năng thường sử dụng",
        description: "Tối ưu hóa quy trình làm việc của bạn với những hành động được sử dụng thường xuyên này.",
        actions: {
          uploadWork: {
            title: "Đăng ký tác phẩm",
            description: "Đăng ký tác phẩm sáng tạo của bạn để được bảo hộ bản quyền và chứng nhận quyền sở hữu hợp pháp.",
            cta: "Đăng ký ngay"
          },
          marketplace: {
            title: "Mua/Bán bản quyền",
            description: "Khám phá thị trường bản quyền, nơi tác giả và doanh nghiệp dễ dàng giao dịch, chuyển nhượng hoặc cấp phép tác phẩm.",
            cta: "Khám phá ngay"
          },
          reportViolation: {
            title: "Báo cáo vi phạm",
            description: "Tham gia báo cáo nhanh các hành vi sử dụng trái phép hoặc xâm phạm bản quyền tác phẩm.",
            cta: "Báo cáo ngay"
          },
          identityProtection: {
            title: "Bảo vệ hình ảnh cá nhân",
            description: "Giữ an toàn cho danh tính, hình ảnh và thương hiệu cá nhân của bạn trong không gian số.",
            cta: "Tham gia ngay"
          }
          // viewCertificates: {
          //   title: "Chứng chỉ của Tôi",
          //   description: "Xem và quản lý các chứng chỉ bản quyền của bạn",
          //   icon: "certificate",
          //   cta: "Xem Chứng chỉ"
          // },
          // manageWorks: {
          //   title: "Quản lý Tác phẩm",
          //   description: "Chỉnh sửa, cập nhật hoặc xóa các tác phẩm được bảo vệ của bạn",
          //   icon: "manage",
          //   cta: "Quản lý Tác phẩm"
          // },
          // analytics: {
          //   title: "Xem Phân tích",
          //   description: "Theo dõi hiệu suất và trạng thái bảo vệ của các tác phẩm của bạn",
          //   icon: "analytics",
          //   cta: "Xem Phân tích"
          // },
          // support: {
          //   title: "Nhận Hỗ trợ",
          //   description: "Liên hệ với đội ngũ hỗ trợ của chúng tôi để được trợ giúp",
          //   icon: "support",
          //   cta: "Liên hệ Hỗ trợ"
          // }
        }
      },

      // Statistics Section
      stats: {
        title: "Thống kê hệ thống",
        subtitle: "Tin tưởng bằng con số - tác động của chúng tôi đối với bảo vệ bản quyền",
        description: "Xem cách Vietrro đang tạo ra sự khác biệt trong việc bảo vệ tài sản trí tuệ trên toàn thế giới.",
        counters: {
          totalUsers: {
            value: "50,000+",
            label: "Tác giả đã đăng ký"
          },
          protectedWorks: {
            value: "500,000+",
            label: "Tác phẩm được bảo vệ"
          },
          detectedViolations: {
            value: "25,000+",
            label: "Vi phạm được ngăn chặn"
          },
          copyrightValueProtected: {
            value: "15.2B VND",
            label: "Giá trị bản quyền được bảo vệ"
          }
        },
        viewDetailedStats: "Xem Thống kê Chi tiết"
      },

      // Call to Action Section
      cta: {
        title: "Sẵn sàng Bảo vệ Tác phẩm của Bạn?",
        subtitle: "Tham gia cùng hàng nghìn tác giả đã tin tưởng Vietrro để bảo vệ quyền sở hữu trí tuệ",
        description: "Bắt đầu bảo vệ các tác phẩm sáng tạo của bạn ngay hôm nay với nền tảng bảo vệ bản quyền toàn diện của chúng tôi. Bắt đầu trong vài phút với các công cụ dễ sử dụng và giám sát được hỗ trợ bởi AI.",
        features: {
          aiMonitoring: "Giám sát bằng AI",
          legalSupport: "Hỗ trợ Pháp lý",
          globalCoverage: "Bao phủ Toàn cầu",
          easyToUse: "Dễ sử dụng"
        },
        buttons: {
          getStarted: "Bắt đầu Miễn phí",
          viewPricing: "Xem Bảng giá",
          bookDemo: "Đặt lịch Demo",
          learnMore: "Tìm hiểu thêm"
        },
        guarantees: {
          freeTrial: "Dùng thử miễn phí 14 ngày",
          noSetupFee: "Không phí thiết lập",
          cancelAnytime: "Hủy bất cứ lúc nào"
        }
      },

      // Common elements
      common: {
        loading: "Đang tải...",
        error: "Đã xảy ra lỗi khi tải dữ liệu",
        retry: "Thử lại",
        noData: "Không có dữ liệu",
        viewMore: "Xem thêm",
        viewLess: "Xem ít hơn",
        showAll: "Hiển thị Tất cả",
        hideAll: "Ẩn Tất cả",
        search: "Tìm kiếm...",
        filter: "Lọc",
        sort: "Sắp xếp",
        date: "Ngày",
        name: "Tên",
        status: "Trạng thái",
        actions: "Thao tác"
      },

      // Error states
      errors: {
        loadingWorks: "Không thể tải tác phẩm gần đây",
        loadingUsers: "Không thể tải tác giả nổi bật",
        loadingCertificates: "Không thể tải chứng chỉ",
        loadingViolations: "Không thể tải báo cáo vi phạm",
        general: "Đã xảy ra lỗi. Vui lòng thử lại sau."
      }

    },
    
  }
}
